import { createFileRoute, redirect } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { PaymentsTabActiveSegment } from '@mews-commander/modules/src/modules/payment';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/$id/_pageLayout/Payment/')({
    staticData: {
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Redirect,
        title: TextKey.PaymentPlural,
    },
    beforeLoad: ({ context: { featureFlagService }, params: { id, currentEnterpriseId } }) => {
        const isNewCustomerPageRouteStructureEnabled = featureFlagService.hasFlag(
            FeatureFlag.newCustomerPageRouteStructureEnabled
        );
        if (!isNewCustomerPageRouteStructureEnabled) {
            throw redirect({
                to: `/$currentEnterpriseId/Payment/Index/$accountId`,
                params: {
                    currentEnterpriseId,
                    accountId: id,
                },
                search: {
                    EnterpriseId: currentEnterpriseId,
                    activeSegment: PaymentsTabActiveSegment.Overview,
                },
            });
        }
        throw redirect({
            to: `/$currentEnterpriseId/Customer/$id/Payment/$activeSegment`,
            params: {
                currentEnterpriseId,
                id,
                activeSegment: PaymentsTabActiveSegment.Overview,
            },
        });
    },
});
